import { Component, Input, OnInit } from '@angular/core';
import { Item } from '../../shared/models/Item';
import { ItemPricing } from '../../shared/models/ItemPricing';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { Distributor } from '../../shared/models/Distributor';
import { HttpService } from '../../shared/services/HttpService';

@Component({
  selector: 'app-price-break',
  templateUrl: './price-break.component.html',
  styleUrls: ['./price-break.component.css']
})
export class PriceBreakComponent implements OnInit {
  @Input() ItemPriceList: Item[];
  //@Input() Item: string;
  //@Input() BreakPricing: ItemPricing[];
  @Input() Customer: Distributor;
  ConfiguredPrice: number;
  @Input() OverridePricingRule: boolean;
  faXmark = faXmark;
  //EffectivePricing: ItemPricing;
  //FuturePricing: ItemPricing;
  //Quantity: number;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  EstLeadTimeVerbiage: string;
  TariffVerbiage: string;
  ShowTariffMessage: boolean;
  constructor(public matDialog: MatDialog, private http:HttpService) {
    this.http.GetEstimatedLeadTimeMessage().then(x => {
      this.EstLeadTimeVerbiage = x.Content;
    });
    this.http.GetTariffMessage().then(x => {
      this.ShowTariffMessage = <boolean>x.Content;
      this.TariffVerbiage = x.Message;
    });
  }


  ngOnInit(): void {
    //this.Quantity = 1
    //this.BreakPricing = [];
    //this.EffectivePricing = new ItemPricing();
    //this.FuturePricing = new ItemPricing();
  }

  //BuildPricing() {
  //  if (this.BreakPricing && this.BreakPricing.length > 0) {
  //    var currentDate = new Date();
  //    this.FuturePricing = this.BreakPricing.filter((price) => { return new Date(price.EffectDate).getTime() > currentDate.getTime()})[0];
  //    var futureDate = new Date();
  //    if (!this.FuturePricing) {
  //      this.FuturePricing = null;        
  //    }
  //    else {
  //      futureDate = new Date(this.FuturePricing[0].EffectDate);
  //    }
  //    var filteredDates = [];
  //    this.BreakPricing.forEach((price) => {
  //      var curDate = new Date(price.EffectDate);
  //      if (curDate.getTime() != futureDate.getTime() && curDate.getTime() <= currentDate.getTime()) {
  //        filteredDates.push(price.EffectDate);
  //      }
  //    });

  //    var dateToGrab = new Date(filteredDates[0]);

  //    this.EffectivePricing = this.BreakPricing.filter((price) =>
  //    {
  //      var curPricingDate = new Date(price.EffectDate);
  //      return curPricingDate.getMonth() == dateToGrab.getMonth() && curPricingDate.getFullYear() == dateToGrab.getFullYear() && curPricingDate.getDay() == dateToGrab.getDay();
  //    })[0];

  //  }
  //}

  BuildConfiguredPricing() {
    var newPricing = new ItemPricing();
    newPricing.UnitPrice = this.ConfiguredPrice;
    //newPricing.Item = this.Item;
    //this.EffectivePricing = newPricing;
  }

  ClearPricing() {
    this.ItemPriceList = [];
    //this.Item = "";
    //this.BreakPricing = [];
    //this.EffectivePricing = new ItemPricing();
    //this.FuturePricing = new ItemPricing();
    //this.Quantity = 1;
  }


  GetDistPrice(item: Item) {
    if (item.Quantity >= item.EffectivePricing.BreakQty5 && item.EffectivePricing.BreakQty5 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice5 / 100.00) * item.EffectivePricing.UnitPrice));
      return item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice5 / 100.00) * item.EffectivePricing.UnitPrice);
    } else if (item.Quantity >= item.EffectivePricing.BreakQty4 && item.EffectivePricing.BreakQty4 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice4 / 100.00) * item.EffectivePricing.UnitPrice));
      return item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice4 / 100.00) * item.EffectivePricing.UnitPrice);
    } else if (item.Quantity >= item.EffectivePricing.BreakQty3 && item.EffectivePricing.BreakQty3 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice3 / 100.00) * item.EffectivePricing.UnitPrice));
      return item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice3 / 100.00) * item.EffectivePricing.UnitPrice);
    } else if (item.Quantity >= item.EffectivePricing.BreakQty2 && item.EffectivePricing.BreakQty2 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice2 / 100.00) * item.EffectivePricing.UnitPrice));
      return item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice2 / 100.00) * item.EffectivePricing.UnitPrice);
    }
    else if (item.Quantity >= item.EffectivePricing.BreakQty1 && item.EffectivePricing.BreakQty1 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice1 / 100.00) * item.EffectivePricing.UnitPrice));
      return item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice1 / 100.00) * item.EffectivePricing.UnitPrice);
    }
    else {
      return item.EffectivePricing.UnitPrice;
    }
  }

  GetDiscount(item:Item):string {
    if (item.Quantity >= item.EffectivePricing.BreakQty5 && item.EffectivePricing.BreakQty5 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice5 / 100.00) * item.EffectivePricing.UnitPrice));
      return Math.abs(Math.trunc(item.EffectivePricing.BreakPrice5)).toString() + "%";
    } else if (item.Quantity >= item.EffectivePricing.BreakQty4 && item.EffectivePricing.BreakQty4 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice4 / 100.00) * item.EffectivePricing.UnitPrice));
      return Math.abs(Math.trunc(item.EffectivePricing.BreakPrice4)).toString() + "%";
    } else if (item.Quantity >= item.EffectivePricing.BreakQty3 && item.EffectivePricing.BreakQty3 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice3 / 100.00) * item.EffectivePricing.UnitPrice));
      return Math.abs(Math.trunc(item.EffectivePricing.BreakPrice3)).toString() + "%";
    } else if (item.Quantity >= item.EffectivePricing.BreakQty2 && item.EffectivePricing.BreakQty2 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice2 / 100.00) * item.EffectivePricing.UnitPrice));
      return Math.abs(Math.trunc(item.EffectivePricing.BreakPrice2)).toString() + "%";
    }
    else if (item.Quantity >= item.EffectivePricing.BreakQty1 && item.EffectivePricing.BreakQty1 > 0) {
      //return item.Quantity * (item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice1 / 100.00) * item.EffectivePricing.UnitPrice));
      return Math.abs(Math.trunc(item.EffectivePricing.BreakPrice1)).toString() + "%";
    }
    return "";
  }

  GetEstLeadTimeText(days: number)
  {
    var returnText = "";
    if (days > 5) {
      var weeks = Math.abs((days / 5));
      returnText = (weeks) + "-" + (weeks + 1) + " weeks";
    }
    else {
      returnText = days.toString() + "-" + (days + 3).toString() + " days";
    }
    return returnText;
}


  RemoveItem(index:number) {
    //var index = 0;
    //for (var i = 0; i < this.ItemPriceList.length; i++) {
    //  if (itemprice.Item == this.ItemPriceList[i].Item) {
    //    index = i;
    //    break;
    //  }
    //}

    this.ItemPriceList.splice(index, 1);

  }

  ViewItemDetails(item: Item) {
    var dialogConfig = this.GetDialogConfig("RMAItem");

    var rmaObject = {
      type: "itemsummary", object: item
    };
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "80%";
    dialogConfig.width = "70%";

    return dialogConfig;
  }

  GetInStockString(available: number):string {
    var retString = "";
    if (available > 100) {
      retString = "100+ in stock";
    } else if (available > 0) {
      retString = available.toString() + " in stock";
    } else {
      retString = "Build to order";
    }



    return retString;
  }

}
